<template>
  <div class="card p-3 mt-4">
    <h5 class="mb-3 section-title card-section-title">Totales de Averías</h5>
    <!-- Filtros: buscador izquierda, fechas derecha (mismo tamaño y posición en todas las tarjetas) -->
    <div class="card-filters-row d-flex flex-wrap align-items-end justify-content-between gap-2 mb-3">
      <div class="card-filters-buscar">
        <label for="buscar_averias" class="form-label">Buscar</label>
        <input
          id="buscar_averias"
          type="text"
          class="form-control"
          v-model="buscar"
          placeholder="Buscar por producto o horno..."
        />
      </div>
      <div class="card-filters-fechas d-flex flex-wrap align-items-end gap-5">
        <div class="card-filters-fecha">
          <label for="fecha_inicio" class="form-label">Fecha inicio</label>
          <input id="fecha_inicio" type="date" class="form-control" v-model="fecha_inicio" />
        </div>
        <div class="card-filters-fecha">
          <label for="fecha_fin" class="form-label">Fecha fin</label>
          <input id="fecha_fin" type="date" class="form-control" v-model="fecha_fin" />
        </div>
      </div>
    </div>
    <div class="row">
      <!-- Gráfico: primero en móvil, a la derecha en pantallas grandes -->
      <div class="col-lg-6 averias-grafico-col order-1 order-lg-2">
        <div class="averias-grafico-wrapper">
          <!-- Tarjeta de valores, alineada a la derecha -->
          <div class="averias-leyenda-superior d-flex justify-content-end mb-3">
            <div class="averias-leyenda-tarjeta">
              <div class="averias-leyenda-item">
                <span class="averias-leyenda-linea averias-color-cargue"></span>
                <span>Cargue: {{ totales.averia_cargue }}</span>
              </div>
              <div class="averias-leyenda-item">
                <span class="averias-leyenda-linea averias-color-secado"></span>
                <span>Secado: {{ totales.averia_secado }}</span>
              </div>
              <div class="averias-leyenda-item">
                <span class="averias-leyenda-linea averias-color-descargue"></span>
                <span>Descargue: {{ totales.averia_descargue }}</span>
              </div>
              <div class="averias-leyenda-item">
                <span class="averias-leyenda-linea averias-color-crudo"></span>
                <span>Crudo: {{ totales.averia_crudo }}</span>
              </div>
            </div>
          </div>
          <!-- Gráfico debajo de la tarjeta -->
          <div class="averias-chart-container">
            <canvas ref="chartCanvas"></canvas>
          </div>
        </div>
      </div>
      <!-- Tablas: segunda en móvil, a la izquierda en pantallas grandes -->
      <div class="col-lg-6 averias-tablas-col order-2 order-lg-1">
        <h6 class="mb-2">Cargue</h6>
        <div class="table-responsive">
        <table class="table table-sm table-averias">
          <thead>
            <tr>
              <th class="text-start">Producto</th>
              <th>Horno</th>
              <th>Cargue</th>
              <th>Secado</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in filteredCargue" :key="item ? `c-${(item.producto||'')}-${(item.horno||'')}-${index}` : `c-empty-${index}`">
              <td class="text-start">{{ item.producto ?? '-' }}</td>
              <td>{{ item.horno ?? '-' }}</td>
              <td>{{ item.averia_cargue }}</td>
              <td>{{ item.averia_secado }}</td>
            </tr>
            <tr v-if="filteredCargue.length === 0">
              <td colspan="4" class="text-center text-muted">No se encontraron resultados</td>
            </tr>
          </tbody>
        </table>
        </div>
        
        <!-- Paginación cargue -->
        <div class="averias-pagination d-flex justify-content-center align-items-center mt-2 gap-2">
          <button type="button" class="averias-pagination-btn" @click="prevPageCargue" :disabled="carguePageDisplay <= 1">&lt;&lt;</button>
          <span class="averias-pagination-text">{{ carguePageDisplay }}/{{ cargueLastPageDisplay }}</span>
          <button type="button" class="averias-pagination-btn" @click="nextPageCargue" :disabled="carguePageDisplay >= cargueLastPageDisplay">&gt;&gt;</button>
        </div>

        <h6 class="mt-3">Descargue</h6>
        <div class="table-responsive">
        <table class="table table-sm table-averias">
          <thead>
            <tr>
              <th class="text-start">Producto</th>
              <th>Horno</th>
              <th>Avería Descargue</th>
              <th>Crudo</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, idx) in descargueRows" :key="item ? `d-${idx}` : `empty-d-${idx}`" :class="{ 'fila-vacia': !item }">
              <td class="text-start">{{ item ? (item.producto ?? '—') : '—' }}</td>
              <td>{{ item ? (item.horno ?? '—') : '—' }}</td>
              <td>{{ item ? item.averia_descargue : '—' }}</td>
              <td>{{ item ? item.averia_crudo : '—' }}</td>
            </tr>
          </tbody>
        </table>
        </div>

        <!-- Paginación descargue -->
        <div class="averias-pagination d-flex justify-content-center align-items-center mt-2 gap-2">
          <button type="button" class="averias-pagination-btn" @click="prevPageDescargue" :disabled="descarguePageDisplay <= 1">&lt;&lt;</button>
          <span class="averias-pagination-text">{{ descarguePageDisplay }}/{{ descargueLastPageDisplay }}</span>
          <button type="button" class="averias-pagination-btn" @click="nextPageDescargue" :disabled="descarguePageDisplay >= descargueLastPageDisplay">&gt;&gt;</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart, ArcElement, Tooltip, Legend } from "chart.js";
Chart.register(ArcElement, Tooltip, Legend);

export default {
  name: "AveriasChart",
  data() {

    
    const fechaInicio = new Date();
    fechaInicio.setDate(fechaInicio.getDate() - 15);
    const fechaFin= new Date();

    // Convertirlas a formato yyyy-MM-dd (sin UTC)
    const formatDate = (d) => {
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    };
    return {
      fecha_inicio: formatDate(fechaInicio),
      fecha_fin: formatDate(fechaFin),
      buscar: '',
      totales: {
        averia_cargue: 0,
        averia_secado: 0,
        averia_descargue: 0,
        averia_crudo: 0,
      },
      listados: {
        cargue: {
          data: [],
          current_page: 1,
          last_page: 1,
        },
        descargue: {
          data: [],
          current_page: 1,
          last_page: 1,
        },
      },
      chartInstance: null,
      debounceAveriasTimer: null,
    };
  },
  computed: {
    filteredCargue() {
      const data = this.listados.cargue?.data || this.listados.cargue || [];
      return Array.isArray(data) ? data : [];
    },
    filteredDescargue() {
      const data = this.listados.descargue?.data || this.listados.descargue || [];
      return Array.isArray(data) ? data : [];
    },
    descargueRows() {
      const minRows = 3;
      const data = this.filteredDescargue;
      const rows = [...data];
      while (rows.length < minRows) rows.push(null);
      return rows;
    },
    carguePageDisplay() {
      const c = this.listados.cargue;
      if (!c) return 1;
      const last = Math.max(1, c.last_page ?? 1);
      const cur = Math.min(Math.max(1, c.current_page ?? 1), last);
      return cur;
    },
    cargueLastPageDisplay() {
      const c = this.listados.cargue;
      return Math.max(1, c?.last_page ?? 1);
    },
    descarguePageDisplay() {
      const d = this.listados.descargue;
      if (!d) return 1;
      const last = Math.max(1, d.last_page ?? 1);
      const cur = Math.min(Math.max(1, d.current_page ?? 1), last);
      return cur;
    },
    descargueLastPageDisplay() {
      const d = this.listados.descargue;
      return Math.max(1, d?.last_page ?? 1);
    },
  },
  watch: {
    fecha_inicio() {
      this.fetchAverias(1, 1);
    },
    fecha_fin() {
      this.fetchAverias(1, 1);
    },
    buscar() {
      this.debouncedFetchAverias();
    },
  },
  methods: {
    debouncedFetchAverias() {
      if (this.debounceAveriasTimer) clearTimeout(this.debounceAveriasTimer);
      this.debounceAveriasTimer = setTimeout(() => this.fetchAverias(1, 1), 400);
    },
    async fetchAverias(pageCargue = 1, pageDescargue = 1, updateChart = true) {
      try {

        let params = {
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          page_cargue: pageCargue,
          page_descargue: pageDescargue,
        };
        if (this.buscar && this.buscar.trim() !== '') {
          params.buscar = this.buscar.trim();
        }
        const res = await this.$store.dispatch('analitycs/getAverias', params);
        const data = res?.data?.data ?? res?.data ?? {};

        this.listados = data.listados || {};
        this.normalizeListadosPagination();
        if (updateChart) {
          this.totales = this.normalizeTotales(data.totales || {});
          this.$nextTick(() => this.renderChart());
        }
      } catch (error) {
        console.error("Error cargando métricas:", error);
        this.totales = this.normalizeTotales(this.totales);
        this.$nextTick(() => this.renderChart());
      }
    },
    
    normalizeTotales(totales) {
      return {
        averia_cargue: Number(totales.averia_cargue) || 0,
        averia_secado: Number(totales.averia_secado) || 0,
        averia_descargue: Number(totales.averia_descargue) || 0,
        averia_crudo: Number(totales.averia_crudo) || 0,
      };
    },
    renderChart(retry = 0) {
      const canvas = this.$refs.chartCanvas;
      const canvasEl = canvas && (typeof canvas.getContext === 'function' ? canvas : (canvas.$el || canvas));
      if (!canvasEl || typeof canvasEl.getContext !== 'function') {
        if (retry < 5) this.$nextTick(() => setTimeout(() => this.renderChart(retry + 1), 200));
        return;
      }

      const labels = ["Cargue", "Secado", "Descargue", "Crudo"];
      const totalesNorm = this.normalizeTotales(this.totales);
      const dataValues = [
        totalesNorm.averia_cargue,
        totalesNorm.averia_secado,
        totalesNorm.averia_descargue,
        totalesNorm.averia_crudo,
      ];
      const totalSum = dataValues.reduce((a, b) => a + b, 0);
      const backgroundColor = ["#36A2EB", "#FFCE56", "#FF6384", "#4BC0C0"];

      // Cuando todos son 0, mostrar un único segmento "Sin datos" para que el gráfico no quede vacío/roto
      let chartLabels = labels;
      let chartData = dataValues;
      let chartColors = backgroundColor;
      if (totalSum === 0) {
        chartLabels = ["Sin datos"];
        chartData = [1];
        chartColors = ["#dee2e6"];
      }

      if (this.chartInstance) {
        this.chartInstance.destroy();
        this.chartInstance = null;
      }

      this.chartInstance = new Chart(canvasEl, {
        type: "doughnut",
        data: {
          labels: chartLabels,
          datasets: [
            {
              data: chartData,
              backgroundColor: chartColors,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          // Círculo completo y estable (sin animación para evitar estados intermedios)
          rotation: -90,
          circumference: 360,
          cutout: "50%",
          animation: false,
          interaction: {
            intersect: false,
            mode: "nearest",
          },
          plugins: {
            legend: { display: false },
            tooltip: {
              enabled: true,
              callbacks: {
                title(items) {
                  const item = items[0];
                  const value = item?.raw ?? 0;
                  return `${item?.label ?? ""}: ${value}`;
                },
                label(context) {
                  const value = context.raw ?? 0;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const pct = total > 0 ? ((value / total) * 100).toFixed(1) : "0";
                  return `Total: ${value} · ${pct}%`;
                },
              },
            },
          },
        },
      });
    },
    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleString("es-ES");
    },
    normalizeListadosPagination() {
      const norm = (obj) => {
        if (!obj || typeof obj !== 'object') return;
        const last = Math.max(1, parseInt(obj.last_page, 10) || 1);
        let cur = parseInt(obj.current_page, 10) || 1;
        cur = Math.min(Math.max(1, cur), last);
        obj.current_page = cur;
        obj.last_page = last;
        if (!Array.isArray(obj.data)) obj.data = [];
      };
      norm(this.listados.cargue);
      norm(this.listados.descargue);
    },
    nextPageCargue() {
      const cur = this.carguePageDisplay;
      const last = this.cargueLastPageDisplay;
      if (cur < last) {
        this.fetchAverias(cur + 1, this.descarguePageDisplay, false);
      }
    },
    prevPageCargue() {
      if (this.carguePageDisplay > 1) {
        this.fetchAverias(this.carguePageDisplay - 1, this.descarguePageDisplay, false);
      }
    },
    nextPageDescargue() {
      const cur = this.descarguePageDisplay;
      const last = this.descargueLastPageDisplay;
      if (cur < last) {
        this.fetchAverias(this.carguePageDisplay, cur + 1, false);
      }
    },
    prevPageDescargue() {
      if (this.descarguePageDisplay > 1) {
        this.fetchAverias(this.carguePageDisplay, this.descarguePageDisplay - 1, false);
      }
    },
  },
  mounted() {
    this.fetchAverias();
  },
  beforeUnmount() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
      this.chartInstance = null;
    }
  },
};
</script>

<style scoped>
.card-section-title.section-title {
  font-weight: 800;
  color: #1f2d5a;
  letter-spacing: 0.6px;
}

.card-section-title.section-title::after {
  content: "";
  display: block;
  width: 44px;
  height: 3px;
  margin-top: 6px;
  border-radius: 999px;
  background: #f6a500;
}

.table.table-averias {
  font-size: 0.8rem;
}

/* Líneas de la tabla muy suaves */
.table-averias thead th,
.table-averias tbody td {
  border-color: rgba(0, 0, 0, 0.04) !important;
  border-bottom-width: 1px;
}
.table-averias tbody tr {
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}
.table-averias thead th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}
.table-averias tbody tr:last-child td {
  border-bottom-color: rgba(0, 0, 0, 0.04) !important;
}

/* Guiones "—" de celdas vacías muy suaves */
.table-averias tbody tr.fila-vacia td {
  color: rgba(0, 0, 0, 0.12);
}

.averias-pagination {
  gap: 0.5rem;
}

.averias-pagination-btn {
  min-width: 28px;
  height: 26px;
  padding: 0 6px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #1f2d5a;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.averias-pagination-btn:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #1f2d5a;
}

.averias-pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.averias-pagination-text {
  font-size: 0.85rem;
  color: #1f2d5a;
  min-width: 2rem;
  text-align: center;
}

.averias-grafico-wrapper {
  position: relative;
}

.averias-leyenda-superior {
  margin-bottom: 0;
}

.averias-leyenda-tarjeta {
  padding: 0.5rem 0.75rem;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.averias-leyenda-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  color: #1f2d5a;
  margin-bottom: 0.35rem;
}

.averias-leyenda-item:last-child {
  margin-bottom: 0;
}

.averias-leyenda-linea {
  display: inline-block;
  width: 20px;
  height: 4px;
  border-radius: 2px;
  flex-shrink: 0;
}

.averias-color-cargue {
  background-color: #36A2EB;
}

.averias-color-secado {
  background-color: #FFCE56;
}

.averias-color-descargue {
  background-color: #FF6384;
}

.averias-color-crudo {
  background-color: #4BC0C0;
}

.table-averias th,
.table-averias td {
  text-align: center;
}

.table-averias th.text-start,
.table-averias td.text-start {
  text-align: left;
}

.averias-chart-container {
  position: relative;
  width: 100%;
  max-width: 360px;
  height: 280px;
  margin-top: 0.75rem;
  margin-left: auto;
  margin-right: auto;
}

.averias-chart-container canvas {
  position: relative;
  width: 100% !important;
  height: 100% !important;
  display: block;
}
</style>
